import React, { useState } from 'react';

import messages from '../messages';
import TOCList from './TOCList';
import './TOCListWithFilters.scss';

const freqFilters = {
  filterAllFreq: () => true,
  filterAnnual: (t) => t.periodicitySerial === 1 || t.periodicitySerial === 8,
  filterInfraAnnual: (t) => t.periodicitySerial === 2 || t.periodicitySerial === 9,
};

const territoryFilters = {
  filterAllTerritory: () => true,
  filterNational: (t) => t.territorySerial === 1,
  filterRegional: (t) => t.territorySerial === 2,
  filterInternational: (t) => t.territorySerial === 3,
};

const archiveFilters = {
  filterAllStatus: () => true,
  filterActive: (t) => t.periodicitySerial === 1 || t.periodicitySerial === 2,
  filterArchived: (t) => t.periodicitySerial === 8 || t.periodicitySerial === 9,
};

const defaultFreqFilterValue = Object.keys(freqFilters)[0];
const defaultTerritoryFilterValue = Object.keys(territoryFilters)[0];
const defaultArchiveFilterValue = Object.keys(archiveFilters)[0];

export default function FilteredTOCList({ tables, header, lang, showRelatedFirstReleases = false }) {
  const trans = messages[lang];

  const [freqFilterValue, setFreqFilterValue] = useState(defaultFreqFilterValue);
  const [territoryFilterValue, setTerritoryFilterValue] = useState(defaultTerritoryFilterValue);
  const [archiveFilterValue, setArchiveFilterValue] = useState(defaultArchiveFilterValue);

  const isAllFilterOnDefaults = () => (
    freqFilterValue === defaultFreqFilterValue &&
    territoryFilterValue === defaultTerritoryFilterValue &&
    archiveFilterValue === defaultArchiveFilterValue
  );

  const setAllFiltersToDefaults = () => {
    setFreqFilterValue(defaultFreqFilterValue);
    setTerritoryFilterValue(defaultTerritoryFilterValue);
    setArchiveFilterValue(defaultArchiveFilterValue);
  };

  const tableFilterFn = (freqFilterValue, territoryFilterValue, archiveFilterValue) => (
    t => (
      freqFilters[freqFilterValue](t) &&
      territoryFilters[territoryFilterValue](t) &&
      archiveFilters[archiveFilterValue](t)
    )
  );

  const filteredTables = tables.filter(tableFilterFn(freqFilterValue, territoryFilterValue, archiveFilterValue));

  return (
    <React.Fragment>
      <div id='stadat-table-filters'>

        <select
          className={freqFilterValue}
          value={freqFilterValue}
          onChange={evt => setFreqFilterValue(evt.target.value)}
        >
          {Object.keys(freqFilters).map(k => (
            <option key={k + new Date()} value={k}>{trans[k]} ({tables.filter(tableFilterFn(k, territoryFilterValue, archiveFilterValue)).length})</option>
          ))}
        </select>

        <select
          className={territoryFilterValue}
          value={territoryFilterValue}
          onChange={evt => setTerritoryFilterValue(evt.target.value)}
        >
          {Object.keys(territoryFilters).map(k => (
            <option key={k} value={k}>{trans[k]} ({tables.filter(tableFilterFn(freqFilterValue, k, archiveFilterValue)).length})</option>
          ))}
        </select>

        <select
          className={archiveFilterValue}
          value={archiveFilterValue}
          onChange={evt => setArchiveFilterValue(evt.target.value)}
        >
          {Object.keys(archiveFilters).map(k => (
            <option key={k} value={k}>{trans[k]} ({tables.filter(tableFilterFn(freqFilterValue, territoryFilterValue, k)).length})</option>
          ))}
        </select>

        {
          !isAllFilterOnDefaults() &&
          <button onClick={setAllFiltersToDefaults}>
            <svg width='13.246' height='14.265' version='1.1' viewBox='0 0 3.5045 3.7745' xmlns='http://www.w3.org/2000/svg'>
              <path d='m0.10641 0 0.001034 0.63563 1.7007 5.1676e-4c0.58561-5.749e-5 1.0605 0.30686 1.0604 0.89246 5.69e-5 0.58117-0.46801 0.88636-1.0475 0.89091l0.01757-0.76792-0.90745 0.55139-0.93122 0.51005 0.93122 0.51005 0.90745 0.55139-0.016537-0.71831c0.93048-0.0058143 1.6827-0.59531 1.6826-1.5276 9.18e-5 -0.93697-0.75959-1.5287-1.6966-1.5286z' fill='#fff' fillRule='evenodd' />
            </svg>
          </button>
        }

      </div>
      <TOCList lang={lang} header={header} tables={filteredTables} showRelatedFirstReleases={showRelatedFirstReleases} />
    </React.Fragment>
  );
}
